import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { DialogsAlertComponent } from '../dialogs-alert/dialogs-alert.component';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { RepresentantsAOC } from 'src/app/core/entities/representantsaoc.model';
import { Representants } from 'src/app/core/entities/representants.model';
import { PersonsByIdNumCtrlDig } from 'src/app/core/entities/personsByIdNumCtrlDig.model';
import { IsProveidor } from 'src/app/core/entities/isproveidor.model';
import { CARGOS_VALIDOS, PETICIONES } from 'src/app/core/utils/constants';
import * as _ from 'lodash';
import { Utils } from 'src/app/core/utils/utils';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class DialogsRepresentantAOCService {

    allrepresentadoAOC: RepresentantsAOC[] = new Array<RepresentantsAOC>();
    dboidRepresentado: string = "";

    nif: string = "";
    isCif: boolean = false;
    isLicencias: boolean;
    isProveidor: IsProveidor = new IsProveidor();

    allPersons: PersonsByIdNumCtrlDig[] = new Array<PersonsByIdNumCtrlDig>();

    /*PRUEBASSSS*/
    allrepresentanteAOC: RepresentantsAOC[] = new Array<RepresentantsAOC>();
    allRepresentants: Representants[] = new Array<Representants>();
    

    constructor(private repositoryService: RepositoryService,
                private dialog: MatDialog,
                private translateService: TranslateService,
                private router: Router) { }

    public comprobarAOC(data: RepresentantsAOC, carpeta: string): Observable<boolean> {
        switch(carpeta){
            case "1": {
                this.nif = data.poderdantdocident;
                this.isCif = Utils.validaCif(this.nif);
                return forkJoin([this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentadoAOC + "/" + this.nif),
                                 this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + this.nif)]).pipe(map(dataGroup => {
                    this.allrepresentadoAOC = _.cloneDeep(dataGroup[0].representantsAOC);
                    this.allPersons = _.cloneDeep(dataGroup[1].personsByIdNumCtrlDig);
                    if(this.allrepresentadoAOC != null){
                        for(let i = 0; i < this.allrepresentadoAOC.length; i++){
                            if(this.allrepresentadoAOC[i].identificadorlegal == data.identificadorlegal){
                                this.dboidRepresentado = _.cloneDeep(this.allrepresentadoAOC[i].dboid);
                                return true;
                            }
                        }
                        return false;
                    }else{
                        return false;
                    }
                }));
            }
            case "2": {
                this.nif = data.poderdantdocident;
                this.isCif = Utils.validaCif(this.nif);
                return forkJoin([this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentadoAOC + "/" + this.nif),
                                 this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + this.nif),
                                 this.repositoryService.doGet(PETICIONES.webservice.doGetActividad + "/" + this.nif)]).pipe(map(dataGroup => {
                    this.allrepresentadoAOC = _.cloneDeep(dataGroup[0].representantsAOC);
                    this.allPersons = _.cloneDeep(dataGroup[1].personsByIdNumCtrlDig);
                    this.isLicencias = _.cloneDeep(dataGroup[2]);
                    if(this.allrepresentadoAOC != null){
                        for(let i = 0; i < this.allrepresentadoAOC.length; i++){
                            if(this.allrepresentadoAOC[i].identificadorlegal == data.identificadorlegal){
                                this.dboidRepresentado = _.cloneDeep(this.allrepresentadoAOC[i].dboid);
                                return true;
                            }
                        }
                        return false;
                    }else{
                        return false;
                    }
                }));
            }
            case "3": {
                this.nif = data.poderdantdocident;
                return forkJoin([this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentadoAOC + "/" + this.nif),
                                 this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + this.nif),
                                 this.repositoryService.doGet(PETICIONES.webservice.doGetProveidors + "/" + this.nif)]).pipe(map(dataGroup => {
                    this.allrepresentadoAOC = _.cloneDeep(dataGroup[0].representantsAOC);
                    this.allPersons = _.cloneDeep(dataGroup[1].personsByIdNumCtrlDig);
                    this.isProveidor = _.cloneDeep(dataGroup[2]);
                    if(this.allrepresentadoAOC != null){
                        for(let i = 0; i < this.allrepresentadoAOC.length; i++){
                            if(this.allrepresentadoAOC[i].identificadorlegal == data.identificadorlegal){
                                this.dboidRepresentado = _.cloneDeep(this.allrepresentadoAOC[i].dboid);
                                return true;
                            }
                        }
                        return false;
                    }else{
                        return false;
                    }
                }));
            }
        }
        
    }

    public comprobarMyCarpeta(nif: string, carpeta: string): Observable<any> {
        switch(carpeta){
            case "1": {
                this.isCif = Utils.validaCif(nif);
                return forkJoin([this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif)]).pipe(map(dataGroup => {
                    this.allPersons = _.cloneDeep(dataGroup[0].personsByIdNumCtrlDig);
                }),catchError((error: any) => {
                    this.errorCargaWS('WARNINGS.error_ws');
                    console.log(error);
                    throw error;
                }));
            }
            case "2": {
                this.isCif = Utils.isCifEmpresa3(nif);
                if(!this.isCif){
                    return forkJoin([this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif),
                                     this.repositoryService.doGet(PETICIONES.webservice.doGetActividad + "/" + nif)]).pipe(map(dataGroup => {
                        this.allPersons = _.cloneDeep(dataGroup[0].personsByIdNumCtrlDig);
                        this.isLicencias = _.cloneDeep(dataGroup[1]);
                    }),catchError((error: any) => {
                        this.errorCargaWS('WARNINGS.error_ws');
                        console.log(error);
                        throw error;
                    }));
                }else{
                    return forkJoin([this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif)]).pipe(map(dataGroup => {
                        this.allPersons = _.cloneDeep(dataGroup[0].personsByIdNumCtrlDig);
                    }),catchError((error: any) => {
                        this.errorCargaWS('WARNINGS.error_ws');
                        console.log(error);
                        throw error;
                    }));
                }
            }
            case "3": {
                return forkJoin([this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif),
                                 this.repositoryService.doGet(PETICIONES.webservice.doGetProveidors + "/" + nif)]).pipe(map(dataGroup => {
                    this.allPersons = _.cloneDeep(dataGroup[0].personsByIdNumCtrlDig);
                    this.isProveidor = _.cloneDeep(dataGroup[1]);
                }),catchError((error: any) => {
                    this.errorCargaWS('WARNINGS.error_ws');
                    console.log(error);
                    throw error;
                }));
            }
        }
    }

    /**
    * @description
    * Abre un cuadro de dialogo para informar de un error
    * @param error Texto a mostrar
    */
    public errorCargaWS(error: any) {
        setTimeout(() => {
            const dialogRef = this.dialog.open(DialogsAlertComponent, {
                disableClose: true,
                hasBackdrop: true,
                data: { texto: this.translateService.instant(error) }
            });
            dialogRef.afterClosed().subscribe(result => {
                console.log(result);
            });
        }, 500);
    }

    public filtroCarpeta (nif: string, carpeta: string): Observable<any> {
        switch(carpeta){
            case "1": {
                this.isCif = Utils.isCifEmpresa3(nif);
                let filtroEmpre = new Array<RepresentantsAOC>();
                if(!this.isCif){
                    return forkJoin([this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentants + "/" + nif),
                                     this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif),
                                     this.repositoryService.doGet(PETICIONES.webservice.doGetActividad + "/" + nif),
                                     this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentaEmpresas + "/" + nif)]).pipe(map(dataGroup => {
                        this.allRepresentants = _.cloneDeep(dataGroup[0].representants);
                        this.allPersons = _.cloneDeep(dataGroup[1].personsByIdNumCtrlDig);
                        this.isLicencias = _.cloneDeep(dataGroup[2]);
                        filtroEmpre = _.cloneDeep(dataGroup[3].representantsAOC);

                        let isCifEmpre: boolean;

                        if(filtroEmpre != null && filtroEmpre.length > 0){
                            for (let i = 0; i < filtroEmpre.length; i++) {

                                isCifEmpre = Utils.validaCif(filtroEmpre[i].poderdantdocident);
                    
                                if(isCifEmpre || filtroEmpre[i].licencia){
                                    this.allrepresentanteAOC.push(filtroEmpre[i]);
                                }
                            }
                        }

                    }),catchError((error: any) => {
                        this.errorCargaWS('WARNINGS.error_ws');
                        this.router.navigate(['/external/empreses/acces']);
                        console.log(error);
                        throw error;
                    }));
                }else{
                    return forkJoin([this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentants + "/" + nif),
                                     this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif),
                                     this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentaEmpresas + "/" + nif)]).pipe(map(dataGroup => {
                        this.allRepresentants = _.cloneDeep(dataGroup[0].representants);
                        this.allPersons = _.cloneDeep(dataGroup[1].personsByIdNumCtrlDig);
                        this.allrepresentanteAOC = _.cloneDeep(dataGroup[2].representantsAOC);
                        if(this.allRepresentants != null){
                            for(let i = 0; i < this.allRepresentants.length; i++){
                                if(this.allRepresentants[i].carrecnom !=  CARGOS_VALIDOS.PRESI || this.allRepresentants[i].carrecnom !=  CARGOS_VALIDOS.PRESI){
                                this.allRepresentants.splice(i, 1);
                                }
                            }
                        }

                        let isCifEmpre: boolean;

                        if(filtroEmpre != null && filtroEmpre.length > 0){
                            for (let i = 0; i < filtroEmpre.length; i++) {

                                isCifEmpre = Utils.validaCif(filtroEmpre[i].poderdantdocident);
                    
                                if(isCifEmpre || filtroEmpre[i].licencia){
                                    this.allrepresentanteAOC.push(filtroEmpre[i]);
                                }
                            }
                        }

                    }),catchError((error: any) => {
                        this.errorCargaWS('WARNINGS.error_ws');
                        this.router.navigate(['/external/empreses/acces']);
                        console.log(error);
                        throw error;
                    }));
                }
            }
            case "2": {
                this.isCif = Utils.validaCif(nif);
                let filtroCiud = new Array<RepresentantsAOC>();
                return forkJoin([this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif),
                                 this.repositoryService.doGet(PETICIONES.webservice.doGetRepresentanteAOC + "/" + nif)]).pipe(map(dataGroup => {
                    this.allPersons = _.cloneDeep(dataGroup[0].personsByIdNumCtrlDig);
                    filtroCiud = _.cloneDeep(dataGroup[1].representantsAOC);
                    let isCifCiud: boolean;

                    if(filtroCiud != null && filtroCiud.length > 0){
                        for (let i = 0; i < filtroCiud.length; i++) {

                            isCifCiud = Utils.validaCif(filtroCiud[i].poderdantdocident);
                
                            if(!isCifCiud){
                                this.allrepresentanteAOC.push(filtroCiud[i]);
                            }
                        }
                    }

                    return this.allrepresentanteAOC;

                }),catchError((error: any) => {
                    this.errorCargaWS('WARNINGS.error_ws');
                    this.router.navigate(['/external/passarela/acces']);
                    console.log(error);
                    throw error;
                }));
            }
        }
    }
    
}